import PropTypes from "prop-types";
import SVG from "react-inlinesvg";
import icons from "./svgManifest";
import "./Svg.scss";

const Svg = ({ icon, className }) => {
    if (icon && icon !== "")
        return <SVG className={`svg ${className}`} src={icons[icon]} cacheRequests />;
    return null;
};

Svg.defaultProps = {
    className: "",
};

Svg.propTypes = {
    icon: PropTypes.string.isRequired,
    className: PropTypes.string,
};

export default Svg;
